
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.026 12.516L23 17.758 20.026 23H14.08l-2.974-5.242 2.974-5.242h5.947zm-1.334 7.734h-3.279a.516.516 0 000 1.031h3.279a.516.516 0 100-1.031zm.262-5.734a.516.516 0 10-.887.531l1.686 2.798a.518.518 0 00.712.177.515.515 0 00.175-.708zM9.576 6.672a.48.48 0 01.417.243l2.702 4.762a.48.48 0 010 .474l-2.702 4.762a.48.48 0 01-.417.243H4.188a.48.48 0 01-.418-.243L1.07 12.151a.48.48 0 010-.474L3.77 6.915a.48.48 0 01.418-.243h5.388zm-5.417 5.092a.518.518 0 00-.705-.2.515.515 0 00-.2.7l1.587 2.855a.518.518 0 00.705.201.515.515 0 00.2-.701zM19.747 1a.48.48 0 01.417.243l2.702 4.762a.48.48 0 010 .474l-2.702 4.762a.48.48 0 01-.417.243h-5.389a.48.48 0 01-.417-.243L11.24 6.48a.48.48 0 010-.474l2.701-4.762A.48.48 0 0114.358 1h5.389zM8.52 8.219H5.242a.516.516 0 000 1.031h3.279a.516.516 0 000-1.031z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    